import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';
import { path } from 'ramda';

import { fullAutoOptions } from 'constants/asyncClient';
import ModalCloseButton from 'components/modals/ModalCloseButton';
import { getCompany } from 'actions/asyncActions';
import CompanyCard from 'components/cards/company/CompanyCard';
import CollapsibleModalContainer from '../CollapsibleModalContainer';

const getCompanyId = path(['params', 'id']);

@withAsyncActions({
    getCompany: getCompany
        .withPayload(getCompanyId)
        .withParams(({ params: { id }}) => ({ id }))
}, fullAutoOptions)
export default class CompanyModal extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        close: PropTypes.func.isRequired,
        getCompany: PropTypes.object.isRequired
    };

    render() {
        const { close, getCompany: { data, meta }, params } = this.props;
        const name = params.text || data.name[0].text;
        const footer = <ModalCloseButton close={close} />;

        return (
            <CollapsibleModalContainer
                meta={meta}
                title={name}
                footer={footer}
            >
                <CompanyCard company={data} meta={meta} />
            </CollapsibleModalContainer>
        );
    }
}
